module.exports = __webpack_public_path__ + "img/check.8bf6037d.svg";